import ForceChangePassword from './ForceChangePasswordContainer'

export default ForceChangePassword



// WEBPACK FOOTER //
// ./src/components/ForceChangePassword/index.js